import React from "react"
import styled from "styled-components"

export const VenuesWrapperStyled = styled.div<any>`
  position: relative;
  padding-top: var(--moje-header-height-web);
  width: 100%;
  min-height: calc(100vh - 80px);

  z-index: 0;

  // Map wrapper for web
  .mapWrapper {
    position: fixed;
    right: 0;
    top: 61px;
    bottom: 0;
    width: 50%;
  }
  .venuesWrapper {
    padding-right: 50%;
    padding-bottom: 32px;
    // padding-top:60px;
    .handler {
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      .handlerTitleWrapper {
        padding-top: 26px;
        ::before {
          content: "";
          display: block;
          position: absolute;
          top: 12px;
          left: 50%;
          transform: translateX(-20px);
          width: 40px;
          height: 4px;
          border-radius: 4px;
          background-color: #E5E5E5;
        }
      }
      .handlerTitle {
        text-align: center;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        white-space: nowrap;
      }
    }
  }

  .venuesGrid {
    padding: 0 40px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 20px 12px;
    padding-top: 20px;
  }

  @media (min-width: 768px) {
    .venuesWrapper {
      .handler {
        display: none;
      }
    }
  }

  @media (max-width: 768px) {
    .mapWrapper {
      display: none;
    }
    .mapCover {
      display: none;
    }
  }

  @media (max-width: 1280px) {
    padding-right: 0;

    .venuesWrapper {
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;

      padding-right: 0;
      z-index: 0;
      position: relative;
      min-height: calc(60vh + 65px);
      will-change: transform;
      transform: translate3d(0, 0, 0);
      width: 100%;

      .handler {
        display: block !important;
        height: 64px;

        // background-color: yellow;
        border-bottom: 1px solid #ccc;
        margin: 0 24px;
      }

      .handlerContent {
        display: flex;
        flex-direction: column;
      }
    }

    .venuesGrid {
      margin-top: 30px;
      padding: 0 20px;
      gap: 10px 12px;
    }

    .mapWrapper,
    .venuesWrapper {
      transition: height 250ms ease;
    }

    .mapWrapper {
      top: 0;
      left: 0;
      right: 0;
      z-index: 0;
      width: 100%;
      inset: 0px 0px auto;
      display: none !important;
      position: fixed;
      height: 100vh;
      flex-direction: column;

      .miniListWrapper {
        .miniListContent {
          display: flex;
          height: 100%;
          list-style: none;
          scroll-snap-type: x mandatory;
          padding: 0;
          overflow: auto hidden;

          .tileWrapper {
            display: inline;
            // width: 80vw;
            border-radius: 20px;

            max-width: 90%;
            flex: 0 0 90%;
            height: 100%;
            margin: 0 10px;

            .content {
              padding-bottom: 100px;
              // padding-top:20px;
              height: 120px;
              background-color: white;
              border-radius: 8px;
              box-shadow: rgba(0, 0, 0, 0.28) 0px 8px 28px;
            }
          }
        }
      }
    }

    

    ${(props) =>
    props.viewMode === VIEW_MODE.BOTH &&
    `
      .mapCover {
        height: calc(40vh - 65px);
        width: 100%;
        appearance: none;
        background: transparent;
        z-index: -1;
      }

      .venuesWrapper {
        // position:absolute; 
        bottom:0;
        z-index:0;
      }
      .miniListWrapper{
        display: none;
      }
    `}

    ${(props) =>
    props.viewMode === VIEW_MODE.MAP &&
    `
      .venuesWrapper {
        transform: translate3d(0, calc(100vh - 65px), 0);
        position:absolute; 
        bottom:0;
        left:0;right:0;
        height:0%;
        z-index:2;
      }
      .mapCover {
        height: calc(100vh - 65px);
      }

      .miniListWrapper {
        display: block;
        position: absolute;
        bottom: 20px;
        left:0px;
        right:0px;
        height: 200px;
      }
    `}
  }
`

export const VIEW_MODE = {
  BOTH: "both",
  MAP: "map",
  LIST: "list",
}
